import React from 'react';
import FadeIn from '../common/FadeIn';
import introImg from '../../assets/images/intro.png';

const AboutHeroSection = () => {
  return (
    <section className="w-full bg-[#f9f9f5] p-8 md:p-14 text-[#1C1917]">
      <div className="max-w-[1140px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center">

          <div className="lg:col-span-6 w-full flex justify-center">
            <FadeIn className="w-full max-w-[480px]">
              <div className="relative w-full aspect-square bg-[#EFECE6] overflow-hidden shadow-xs">
                <img
                  src={introImg}
                  alt="Princy Patel - Web Designer & Founder of SeaSalt Creative"
                  className="w-full h-full object-cover object-top"
                  loading="eager"
                  decoding="async"
                  width="480"
                  height="480"
                />
              </div>
            </FadeIn>
          </div>

          <div className="lg:col-span-6 w-full flex flex-col justify-center text-left lg:pl-4">
            <FadeIn>
              <span className="font-interDisplayMedium uppercase mb-3 block text-black leading-[1.8] tracking-[0.1em] text-[13px] md:text-base font-normal">
                The Story Behind SeaSalt Creative — Princy Patel
              </span>
            </FadeIn>

            <FadeIn>
              <h1 className="font-saolDisplayItalic leading-[1.2] tracking-[0em] text-[26px] md:text-[38px] font sm:mb-6 max-w-[480px] font-light">
                Hi, I'm Princy Patel. SeaSalt Creative was started to make getting a website easier for small businesses and creatives.
              </h1>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] md:text-[16px] font-light black leading-[1.8] tracking-[0em] max-w-[460px]">
                As a web designer, I start with a design you like and customize it with your own content, photos, videos, logo, colors, and other brand details.
                <br />
                No need to start a website from scratch. You choose the style, I make the changes, and together we get your website ready to share.
              </p>
            </FadeIn>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutHeroSection;
